import { StepShell } from "../ui/StepShell.js";
import { OptionCard } from "../ui/OptionCard.js";
import type { EstimatorFlow } from "../../state/useEstimatorFlow.js";

const TIMELINE_OPTIONS = [
  { id: "asap", label: "As soon as possible" },
  { id: "1_3_months", label: "1–3 months" },
  { id: "3_6_months", label: "3–6 months" },
  { id: "6_12_months", label: "6–12 months" },
  { id: "flexible", label: "I'm flexible" }
];

export function Step6Timeline({ flow }: { flow: EstimatorFlow }) {
  const timeline = flow.getAnswer("timeline_window") as string | undefined;

  return (
    <StepShell
      title="When are you hoping to start?"
      helpText="This doesn't change your estimate, but it helps us tailor next steps."
      onBack={flow.goBack}
      onNext={() => {
        flow.goNext();
        void flow.calculate();
      }}
      nextLabel="See my estimate"
    >
      <div className="option-grid" role="radiogroup" aria-label="Desired start window">
        {TIMELINE_OPTIONS.map((opt) => (
          <OptionCard
            key={opt.id}
            name="timeline_window"
            value={opt.id}
            label={opt.label}
            checked={timeline === opt.id}
            onChange={(checked) => checked && flow.setAnswer("timeline_window", opt.id)}
          />
        ))}
      </div>
    </StepShell>
  );
}
